module.exports = __webpack_public_path__ + "img/zip-code.9a084b2e.svg";